export const selectAccount = state => state.account